import styled from "styled-components";
import { TimePicker as antdPicker } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";

const BaseTimePicker = styled(antdPicker)`
  & {
    border: none !important;
    border-bottom: 1px solid ${(props) => props.theme.colors.greyOne} !important;
    border-radius: 0 !important;
    width: 100%;
    padding: 0 !important;
    & > button.ant-btn-primary{
      background-color: ${(props) => props.theme.colors.buttonBlue};;
    }

    input {
      color: ${(props) => props.theme.colors.black};
      font-size: 16px;
      @media (min-width: 768px) {
        font-size: 20px;
        line-height: 28px;
      }
      &::placeholder,
      &::selection {
        color: ${(props) => props.theme.colors.black} !important;
      }
    }
  }
`;

export function TimePicker({ ...props }): JSX.Element {
  return (
    <BaseTimePicker
      suffixIcon={<ClockCircleOutlined style={{ color: "#65696A" }} />}
      {...props}
    />
  );
}
